const dispatch = require("~/store.js").dispatch;

const events = require("./questionChangeEvents.js");

const questionChangeDispatchers = {
    AnswersChanged(questionIDPath, answerSelections, additionalComment, Task) {
        const changed = events.AnswersChanged.New(questionIDPath, answerSelections, additionalComment, Task);
        dispatch(changed);
    }
};

module.exports = questionChangeDispatchers;


// WEBPACK FOOTER //
// ./src/events/questionChange/questionChangeDispatchers.js